import { PrivateRoute } from "../../shared/private-route";
import Tasks from "./container";
import Menu from "./menu";
import TaskStatuses from "./task-statuses/list-container";
import AddTaskStatus from "./task-statuses/add";
import EditTaskStatus from "./task-statuses/edit";
import TaskStatusOrder from "./task-statuses/order/container";

const TaskRoutes = () => {
  return (
    <>
      <PrivateRoute path="/films/:filmId/tasks" component={Menu} />
      <PrivateRoute path="/films/:filmId/task-statuses" component={Menu} />
      <PrivateRoute
        path="/films/:filmId/tasks"
        component={Tasks}
      />


      <PrivateRoute
        path="/films/:filmId/task-statuses"
        component={TaskStatuses}
      />

      <PrivateRoute
        path="/films/:filmId/task-statuses/add"
        component={AddTaskStatus}
      />

      <PrivateRoute
        path="/films/:filmId/task-statuses/:taskStatusId/edit"
        component={EditTaskStatus}
      />

      <PrivateRoute path="/films/:filmId/task-statuses/order" component={TaskStatusOrder} />


    </>
  );
};

export default TaskRoutes;
